import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GATEWAY_URL } from '../constants';
import { IDocumentReferenceProductDTO } from '../model';

@Injectable()
export class DocumentReferenceApiService {
  private readonly http = inject(HttpClient);
  private readonly gatewayUrl = inject(GATEWAY_URL);

  public getDocumentTypes(
    tenantLobProductId: string,
    reference: string,
    filter?: string
  ): Observable<IDocumentReferenceProductDTO[]> {
    const url = `${this.getBaseUrl()}/GetDocumentTypes/tenantLobProduct/${tenantLobProductId}/reference/${reference}`;
    return this.http.get<IDocumentReferenceProductDTO[]>(filter ? `${url}?filter=${filter}` : url);
  }

  private getBaseUrl(): string {
    let baseUrl = this.gatewayUrl;

    return `${baseUrl}/api/DocumentReference`;
  }
}
